/**
 * @name 渠道商表格组件
 */

import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Operator, _MSGTYPES } from '../../constant/msgType';
import { BusinessType } from '../../shared/msg-interface/data-model';
import { ChannelComponent, ChannelPipe } from '../biztype/channel/channel.component';
import { DialogService } from '../../services/dialog.service';
import { ModalHelper } from '@delon/theme';
import { Router } from '@angular/router';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'icc-channel-table',
  templateUrl: './icc-channel-table.component.html',
  styles: [],
})
export class IccChannelTableComponent implements OnInit {
  /** 激活的消息类型 */
  @Input() currentMsgType: any = null;
  /** 业务类型 */
  @Input() businessType: BusinessType = {};
  /** 渠道商有更改 */
  @Output() channelChange = new EventEmitter<any>();
  /** 常量-消息类型 */
  MSGTYPE = _MSGTYPES.MT;

  constructor(private dialogService: DialogService, private modal: ModalHelper, private router: Router) {}

  // 是否编辑
  isEdit: boolean = false;

  ngOnInit() {
    // 根据url判断是不是编辑状态
    if (this.router.url) {
      let ext = this.router.url.split('manage')[1];
      if (ext) {
        this.isEdit = true;
      } else {
        this.isEdit = false;
      }
    }
  }

  /** 打开渠道商弹窗 */
  openChannelModal(channelProvider, msgType: string, carrierId: number, currentMsgType: any) {
    const { ignoreAudit, selectedMsgTypeList } = this.businessType;
    // 管道:订阅号没有免审
    const pipe: ChannelPipe = ignoreAudit ? { hidden: channel => Number(channel.wechatType) === 1 } : {};

    if (!channelProvider.channelProportion) {
      this.dialogService.notification.warning('选择渠道商', '该渠道商没有设定下发占比');
      return;
    }

    let allChoosedChannels = [];
    currentMsgType.channelProviders.forEach(item => {
      allChoosedChannels.push(...item.channels);
    });

    // 若为5g消息，编辑业务类型时，若变更5G消息渠道，提示：若变更渠道，5G消息素材将不可用，导致消息下发失败，是否继续？
    if (Number(msgType) === _MSGTYPES.MT._5G.type && this.isEdit) {
      const messages = '若变更渠道，5G消息素材将不可用，导致消息下发失败，是否继续?';
      const options1 = {
        confirm: () => {
          this.modal.createStatic(ChannelComponent, { pipe, channelProvider, msgType, carrierId, msgTypes: selectedMsgTypeList }, { size: 'lg' }).subscribe(data => {
            channelProvider.channels = [];
            data.forEach(channel => {
              channelProvider.channels.push({
                id: 0,
                bizTypeId: this.businessType.id || 0,
                msgType: Number(msgType),
                channelId: channel.id,
                channelName: channel.name,
                channelNum: channel.channelNum,
                providerId: channelProvider.id,
                carrierId,
                wechatType: channel.wechatType,
                providerName: channelProvider.name,
                carrierName: channelProvider.carrierName,
                identity: channel.identity,
              });
              // 微信特殊情况处理
              this.handleWechatInChannel(channel);
            });
            this.channelChange.next();
          });
        }, // 确定绑定方法
      };
      this.dialogService.modal.confirm('选择渠道商', messages, options1);
      return;
    }

    this.modal.createStatic(ChannelComponent, { pipe, channelProvider, msgType, carrierId, msgTypes: selectedMsgTypeList }, { size: 'lg' }).subscribe(data => {
      channelProvider.channels = [];
      data.forEach(channel => {
        channelProvider.channels.push({
          id: 0,
          bizTypeId: this.businessType.id || 0,
          msgType: Number(msgType),
          channelId: channel.id,
          channelName: channel.name,
          channelNum: channel.channelNum,
          providerId: channelProvider.id,
          carrierId,
          wechatType: channel.wechatType,
          providerName: channelProvider.name,
          carrierName: channelProvider.carrierName,
          identity: channel.identity,
        });
        // 微信特殊情况处理
        this.handleWechatInChannel(channel);
      });
      this.channelChange.next();
    });
  }

  /** 渠道商改变 */
  proportionChange($event, provider) {
    // 没有选择渠道，则置空渠道
    if (!$event || $event.value < 0) provider.channels = [];
  }
  /** 处理微信特殊情况 */
  handleWechatInChannel(channel) {
    const { wechatType = '' } = channel;
    const { selectedMsgTypeList = [] } = this.businessType;

    const weChatMsgType = selectedMsgTypeList.find(mt => Number(mt.value) === this.MSGTYPE.WECHAT.type);

    // 订阅号
    if (wechatType === 1) {
      weChatMsgType.applicationTypeList.find(it => it.id === 25).isDisabled = true;
      weChatMsgType.selectedApplicationType = weChatMsgType.applicationTypeList.find(it => it.id === 24);
      // 订阅号不能免审
      this.businessType.ignoreAudit = false;
      this.businessType.hasSubscription = true;
    }

    // 服务号
    if (wechatType === 0) {
      weChatMsgType.applicationTypeList.find(at => at.id === 25).isDisabled = false;
      this.businessType.hasSubscription = false;
    }
  }

  /** 渠道校验 */
  validateChannel() {
    const { selectedMsgTypeList = [] } = this.businessType;
    return selectedMsgTypeList.some(msgType => {
      const { channelProviders, label, value } = msgType;

      if (!channelProviders || channelProviders.length <= 0) {
        this.dialogService.notification.error('提示', `请为[${label}]填写渠道信息`);
        return true;
      } else {
        let sumProvider = 0;
        const sumCarrier = {};

        const invalid = channelProviders.some(provider => {
          const { channelProportion, channels, carrierId, name } = provider;

          // 情况1：渠道商有百分百，但是没有选择具体的渠道
          if (channelProportion > 0 && (!channels || channels.length <= 0)) {
            this.dialogService.notification.error('提示', `请为[${label}]${value === _MSGTYPES.MT.SMS.type.toString() || value === _MSGTYPES.MT._5G.type.toString() ? '-[' + Operator[carrierId] + ']' : ''}-[${name}]选择具体下发渠道`);
            return true;
          }
          // 情况2：所选渠道数大于渠道商百分百
          if (channelProportion < channels.length) {
            this.dialogService.notification.error('提示', '所选渠道数必须小于等于渠道商百分比');
            return true;
          }
          // 非短信和5G渠道商百分占比统计
          if (Number(value) !== _MSGTYPES.MT.SMS.type && Number(value) !== _MSGTYPES.MT._5G.type) {
            sumProvider = sumProvider + channelProportion;
          } else {
            // 短信、5G运营商百分比统计
            sumCarrier[carrierId] = sumCarrier[carrierId] ? sumCarrier[carrierId] + channelProportion : channelProportion;
          }
          // 情况3：为5g消息的话，每个渠道商只能选择一个渠道，且单渠道占比为100%
          if (Number(value) === _MSGTYPES.MT._5G.type && channelProportion != 100 && channelProportion != 0) {
            this.dialogService.notification.error('提示', '5G消息单渠道占比必须为100%');
            return true;
          }
        });

        // 格式错误
        if (invalid) return true;

        //  情况3：非短信、5G，渠道商百分比必须为100%
        if ((Number(value) !== _MSGTYPES.MT.SMS.type && Number(value) !== _MSGTYPES.MT._5G.type) && sumProvider !== 100) {
          this.dialogService.notification.error('提示', `[${label}]渠道商总占比必须为100%`);
          return true;
        } else {
          let hasCarrier = false;
          for (let key in sumCarrier) {
            if (sumCarrier[key] === 100) {
              hasCarrier = true;
            } else if (sumCarrier[key] > 0 && sumCarrier[key] !== 100) {
              // 情况4：短信、5G，渠道商百分比综合必须为100%
              this.dialogService.notification.error('提示', `运营商[${Operator[key]}]下渠道商占比总和必须为100%`);
              return true;
            }
          }
          if (!hasCarrier) {
            // 情况5：短信、5G，运营商没有选择渠道
            this.dialogService.notification.error('提示', `必须至少一个运营商的渠道商占比设为100%`);
            return true;
          }
        }
      }
    });
  }
}
